export default {
  "home": "首页",
  "ai": "AI开放平台首页",
  "deepcam": "神目科技官网",
  "experience": "线上体验",
  "learn": "学习中心",
  "login": "登录",
  "register": "注册",
  "app": "应用管理",
  "adminapp": "应用管理",
  "device": "应用设备",
  "sdk": "SDK中心",
  "sdkList":"SDK列表",
  "sdkFiles":"SDK文件",
  "announcement": "公告中心",
  "personal": "个人中心",
  "user": "用户管理",
  "sdkManagement": "SDK管理",
  "relationship": "设置关联",
  "screen": "全屏",
  "outScreen": "退出全屏",
  "quit": "安全退出",
  "appList": "应用列表",
  "warrant": "授权文件列表",
  "global": {
    "not": "不能为空",
    "rules1": "密码只能输入6~16位字符，且不能出现空格",
    "rules2": "邮箱格式不正确",
    "rules3": "手机格式不正确",
    "input2": "请输入密码",
    "input3": "请再次输入密码",
    "input4": "请输入邮箱",
    "input5": "请输入手机号",
    "pswDifferent": "两次输入的密码不一致",
    "label1": "是否激活",
    "on": "激活",
    "off": "不激活",
    "cancel": "取 消",
    "confirm": "确 定",
    "prompt": "提示",
    "label2": "sdk名称",
    "label3": "SDK类型",
    "label4": "请选择",
    "label8": "创建时间",
    "label9": "更新时间",
    "label10": "操作",
    "title1": "编辑",
    "title3": "删除",
    "add": "新增",
    "search": "搜索",
    "contactUs": "联系我们",
    "copyright": "版权所有©2018 神目科技（中国） [鄂ICP备18001234号-2]",
    //添加
    "rule4":"必须是整数",
    "loadFail1": "只能上传.txt格式的文件",
    "loadFail3": "只能上传.rar,.zip格式的文件",
    "loadFail4": "文件必须小于300MB",
    "loadFail2": "请选择mac文件进行上传",
    "err401":"您没有浏览这个页面的权限",
    "err404":"您的页面好像飞走了",
    "err500": "鬼知道服务器经历了什么",
    "back": "返回首页",
    "prve": "返回上一页",
    "admin": "管理员",
    "enterprise":"企业用户"
  },
  "publicHome": {
    "title1": {
      "title": "基于自主专利技术，提供AI服务",
      "iconName0": "人脸检测",
      "iconName1": "人脸跟踪",
      "iconName2": "人脸比对",
      "iconName3": "活体检测",
      "iconName4": "年龄属性",
      "iconName5": "性别属性"
    },
    "title2": {
      "title": "满足多行业场景需求，我们切身实践",
      "iconName0": "智能楼宇",
      "iconName1": "智慧安防",
      "iconName2": "智慧零售",
      "iconName3": "智慧教育",
      "iconName4": "智慧旅游",
      "iconName5": "智能机器人"
    },
    "title3": {
      "title": "我们的优势",
      "iconName0": "技术能力",
      "iconContent0": "由来自卡内基梅隆大学及全国领先生物识别研究所等世界一流团队倾心打造",
      "iconName1": "准确度",
      "iconContent1": "经过行业商用场景千锤百炼，更领先的精准度",
      "iconName2": "适应性强",
      "iconContent2": "各种复杂环境下的强鲁棒性，在多种设备上拥有强劲性能表现"
    },
    "title4": {
      "title": "支持的平台与配置",
      "Windows": "<p>最低硬件配置（可运行算法）</p><p class=\"gray\">Intel® CoreTM i5-2300@2.80GHz 或者同级别芯片</p><p>推荐硬件配置（具有良好的体验）</p><p class=\"gray\">Intel® CoreTMi7-4600U@2.1GHz 或者同级别芯片</p><p>系统版本要求</p><p class=\"gray\">Windows 7 及以上</p>",
      "Android": "<p>推荐硬件配置（具有良好的体验）</p><p class=\"gray\">RK3288、RK3399或者同级别芯片</p><p>系统版本要求</p><p class=\"gray\">Android 5.0 及以上</p>",
      "Linux": "<p>最低硬件配置（可运行算法）</p><p class=\"gray\">Intel® CoreTM i3-4330 Processor</p><p>推荐硬件配置（具有良好的体验）</p><p class=\"gray\">Intel® CoreTM i7-5775R Processor</p><p>系统版本要求</p><p class=\"gray\">Ubuntu 14.04及以上</p>",
      "IOS": "<p>最低硬件配置（可运行算法）</p><p class=\"gray\">Apple A7</p><p>推荐硬件配置（具有良好的体验）</p><p class=\"gray\">Apple A9</p><p>系统版本要求</p><p class=\"gray\">iOS 8.0 及以上</p>"
    },
    "title5": {
      "title": "人脸识别产品免费开放",
      "mark": "等待您的加入",
      "join": "立即加入"
    },
    "footer": {
      "followUs": "关注我们",
      "address": "地址",
      "addressDes": "深圳市龙华区观湖街道松元厦社区虎地排117号锦绣大地7号楼401",
      "phone": "电话",
      "mail": "邮箱",
      "sendmail": "发送邮箱",
      "shenzhen": "（深圳）",
      "wuhan": "（武汉）"
    }
  },
  "webPage": {
    "login": {
      "input1": "请输入账号/手机号",
      "input3": "记住密码",
      "sub": "登录",
      "goReg": "去注册",
      "goHome": "返回首页"
    },
    "oblivion": {
      "title": "忘记密码",
      "input1": "确认",
      },
    "register": {
      "input1": "请输入账号",
      "input6": "请输入手机六位验证码",
      "getCode": "获取验证码",
      "sub": "注册",
      "golog": "去登录",
      "goHome": "返回首页",
      "rules4": "验证码输入不完整",
      "failCode": "验证码获取失败",
      "confirmPhone": "请输入正确的手机号码"
    },
    "app": {
      "label1": "应用名称",
      "label4": "包名",
      "label5": "使用时间",
      "label6": "状态",
      "label7": "创建时间",
      "title1": "下载SDK",
      "title2": "查看设备",
      "title3": "编辑应用信息",
      "label10": "是否激活",
      "note1": "此操作将永久删除该应用, 是否继续？",
      "loadFail": "请先激活设备再下载",
      //添加
      "label2":"最大激活数量",
      "label3":"到期时间"
    },
    "device": {
      "return": "返回",
      "note1": "此操作将永久删除该设备, 是否继续？"
    },
    "sdk": {
      "add": "新建应用",
      "title1": "创建应用",
      "label1": "app名",
      "label2": "包名",
      "label3": "mac文件",
      "label4": "mac开始",
      "label5": "mac结束",
      "label6": "使用场景",
      "label7": "使用行业",
      "label8": "是否激活",
      "input1": "请输入app应用名称",
      "note": "例如",
      "select": "选取文件",
      "input2": "请输入mac范围的开始",
      "input3": "请输入mac范围的结束",
      "customize": "（定制）"
    },
    "personal": {
      "title1": "基本信息",
      "title2": "用户名",
      "title3": "用户ID",
      "title4": "手机号",
      "title5": "邮箱",
      "title6": "新密码",
      "title7": "确认密码",
      "title8": "保存修改",
      "label1": "是否修改密码",
      "pswUpdate": "密码已更新，请重新登录"
    }
  },
  "adminPage": {
    "user": {
      "userType": "请选择用户类型",
      "label1": "高级用户",
      "label2": "企业用户",
      "input1": "请输入用户名",
      "input2": "请输入用户手机号",
      "input3": "请输入用户邮箱",
      "label3": "用户名",
      "label4": "手机号",
      "label5": "邮箱",
      "label6": "类型",
      "label7": "状态",
      "title2": "重置密码",
      "title4": "创建",
      "label11": "用户类型",
      "note1": "此操作将重置密码, 是否继续？",
      "note2": "此操作将永久删除该用户, 是否继续？",
      "reset": "密码重置成功，默认密码为123456",
      "resetFail": "密码重置失败",
      "input4": "请输入有效时间(月)",
      //添加
      "input5":"mac最大数量（最多85个）",
      "input6":"企业用户可以注册的用户数量",
      "input7": "用户可创建的app数量",
      "input8": "高级用户可以注册的用户数量",
      "rule2": "请输入0~85之间的整数",
      "label8": "密码",
      "label9": "确认密码",
      "label10": "有效时间",
      "label12": "用户数量",
      "label13": "app数量",
      "label14": "Mac数量",
      "label15": "普通用户"
    },
    "app": {
      "title": "创建",
      "label1": "应用名称",
      "label2": "AppKey数量"
    },
    "sdk": {
      "userType": "请选择用户",
      "sdkType": "请选择sdk类型",
      "label3": "SDK加密方式",
      "title1": "编辑SDK",
      "title2": "创建SDK",
      "label5": "Sdk路径",
      "label6": "永久激活",
      "label7": "账号类型",
      "note1": "此操作将永久删除该SDK, 是否继续？",
      "note2": "此操作将永久删除该SDK文件, 是否继续？",
      "label1":"文件名",
      "label2":"文件地址",
      "label4": "状态",
      "text1":"已删除",
      "text2":"正常",
    },
    "association": {
      "userType": "请选择用户",
      "sdkType": "请选择sdk",
      "label1": "用户名",
      "title1": "创建账户与SDK的关联",
      "note1": "此操作将永久删除该user与sdk对应信息, 是否继续？"
    }
  }
}



// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN.js